export const UPDATE_AUTO_STATE = 'UPDATE_AUTO_STATE';
export const ADD_PAGE_TO_SKIP_LIST = 'ADD_PAGE_TO_SKIP_LIST';
export const REMOVE_PAGE_FROM_SKIP_LIST = 'REMOVE_PAGE_FROM_SKIP_LIST';
export const UPDATE_DEEP_AUTO_STATE = 'UPDATE_DEEP_AUTO_STATE';
export const DELETE_CERTAIN_AUTO_DATA = 'DELETE_CERTAIN_AUTO_DATA';
export const RENAME_CERTAIN_AUTO_DATA = 'RENAME_CERTAIN_AUTO_DATA';
